import React, { Fragment } from "react";
import { node, bool, object, func, string } from "prop-types";

/* Any padding/margin for modal content should be handled within the children themselves */

const Modal = ({ isOpen, children, onClose, style = {}, className = "" }) => (
  <Fragment>
    {isOpen && (
      <div
        className={`modal_fullScreen align-items-center ${className}`}
        style={style}
      >
        {onClose ? (
          <div className="row d-flex justify-content-end m-1 mx-sm-5">
            <span
              className="modal_fullScreen-close text-darkGrey"
              onClick={onClose}
            >
              <i className="icomoon-cross-thin" />
            </span>
          </div>
        ) : null}
        <div className="container">
          <div className="row d-flex justify-content-center h-100">
            <div className="col">{children}</div>
          </div>
        </div>
      </div>
    )}
  </Fragment>
);

Modal.propTypes = {
  isOpen: bool,
  children: node,
  onClose: func,
  style: object,
  className: string,
};

export default Modal;
